// extracted by mini-css-extract-plugin
module.exports = {"linkerWrapper":"Hyperlink_linkerWrapper__3Vj9e","open":"Hyperlink_open__1mi4d","editingWrapper":"Hyperlink_editingWrapper__282a3","separator":"Hyperlink_separator__2Qmkg"};